[{
    "heading": "Uninsured/Underinsured Motorist",
    "flowId": "uimui",
    "substeps": [{
        "id": "uimui-digital-signature-consent",
        "heading": "Digital Signature Consent",
        "route": "uimui-consent",
        "flowId": "uimui",
        "active": false,
        "completed": true
      },
      {
        "id": "uimui-non-digital-elections",
        "heading": "Non-Digital Elections",
        "route": "uimui-non-digital",
        "flowId": "uimui",
        "active": true,
        "completed": false
      }
    ]
  },
  {
    "heading": "Personal Injury Protection",
    "flowId": "pip",
    "substeps": [{
        "id": "pip-digital-signature-consent",
        "heading": "Digital Signature Consent",
        "route": "pip-consent",
        "flowId": "pip",
        "active": false,
        "completed": true
      },
      {
        "id": "pip-non-digital-elections",
        "heading": "Non-Digital Elections",
        "route": "pip-non-digital",
        "flowId": "pip",
        "active": true,
        "completed": false
      }
    ]
  }
]
